import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=200d8120&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"
import style0 from "./Rule.vue?vue&type=style&index=0&id=200d8120&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d8120",
  null
  
)

export default component.exports